<template>
    <div class="proposal-table px-3">
        <b-table-simple responsive borderless class="table-sm">
            <b-thead>
                <b-tr>
                    <b-th class="align-middle text-center">No.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 200px;">Summary of Settlement Items</b-th>
                    <b-th class="align-middle text-center" style="min-width: 120px;">Current Outstanding</b-th>
                    <b-th class="align-middle text-center" style="min-width: 120px;">Merchant Sett.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 120px;">Invinity Credit Sett.</b-th>
                    <b-th class="align-middle text-center" style="min-width: 120px;">Account Number</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in tableData" :key="index">
                    <b-td class="align-middle text-center">{{ index + 1 }}</b-td>
                    <b-td class="align-middle text-center">{{ item.pcom_capacity }} - {{ item.pcom_bank_code || 'N/A'  }}(Facility: {{ item.pcom_loan_statue || 'N/A' }})</b-td>
                    <b-td class="align-middle text-center">{{ item.pcom_current_outstanding | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ item.pcom_merchant_solution | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ item.pcom_invinity_solution | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">
                        <b-form-input type="text" v-model="item.pcom_account_number" @keydown="preventNonNumericInput"  size="mini"></b-form-input>
                    </b-td>
                </b-tr>
            </b-tbody>
            <b-tfoot>
                <b-tr class="font-weight-600">
                    <b-td colspan="2" class="align-middle text-right">
                        <p class="font-weight-500">Summary</p>
                    </b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, item) => acc + (isNaN(parseFloat(item.pcom_current_outstanding)) ? 0 : parseFloat(item.pcom_current_outstanding)), 0) | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, item) => acc + (isNaN(parseFloat(item.pcom_merchant_solution)) ? 0 : parseFloat(item.pcom_merchant_solution)), 0) | moneyFormatter }}</b-td>
                    <b-td class="align-middle text-center">{{ tableData.reduce((acc, item) => acc + (isNaN(parseFloat(item.pcom_invinity_solution)) ? 0 : parseFloat(item.pcom_invinity_solution)), 0) | moneyFormatter }}</b-td>
                </b-tr>
            </b-tfoot>
        </b-table-simple>
        <div class="text-right">
            <el-button size="mini" type="primary" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
        </div>
    </div>
</template>
<script>
import { Select, Option, Button } from 'element-ui'
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import {isEqual} from 'lodash'

export default {
    props:['proposal'],
    mixins: [notifyFunctionMixin],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
    },
    data() {
        return {
            tableData: [],
            originalTableData: [],
            is_updated: false,
            is_loading: false,
        }
    },
    watch:{
        'proposal.summary_commitments':{
            handler(newVal){
                this.tableData = []
                this.originalTableData = []

                newVal.forEach(item => {
                    this.tableData.push(item)
                    this.originalTableData.push({...item})
                });
            },
            immediate:true
        }
    },
    methods: {
        update(){
            var axiosCalls = []
            this.is_loading = true

            this.tableData.forEach((item) => {
                const original_item = this.originalTableData.find(o_item => o_item.pcom_id === item.pcom_id)
                if(!isEqual(original_item, item)){
                    axiosCalls.push(this.updateSettlementAccountNumber(item))
                }
            })

            Promise.all(axiosCalls)
                .then(res  => {
                    this.notifySuccess('<b>Settlement Summary</b> - Successfully Updated.')
                    this.is_loading = false
                    if(axiosCalls.length > 0){
                        initialProposalEventBus.$emit('refresh-proposal-detail')
                    }
                })
                .catch(e => {
                    this.is_loading = false
                    this.errorFunction(e)
                })
        },
        updateSettlementAccountNumber(proposal){
            return axios.post(services.initial_proposal + 'ccris-item/' + proposal.pcom_id, proposal, {headers: getHeader()} )
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
    }
}
</script>